import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ParentsConsultProfileFormComponent} from "./consult-profile";
import {Link} from "react-router-dom";
import {ThinAddIcon, ThinArrowLeft, ThinChatIcon, ThinChatUnreadIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {ParentsConsultAddRequestModal} from "./add-request";

interface consultRequestInterface {
    id: number,
    description: string,
    createdAt: string,
    isSessionHeld: boolean,
    isAnswered: boolean,
}

export const StudentsConsultOverviewScreen = () => {
    const [formCompleted, setFormCompleted] = useState(false);
    const [requests, setRequests] = useState<consultRequestInterface[]>([]);
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/consult/overview',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                isCompleted: boolean,
                requests: consultRequestInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setRequests(d.requests === null ? [] : d.requests);
                setFormCompleted(d.isCompleted);
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "مشاوره | نهال";
        fetchData();
    }, []);
    const [requestModal, setRequestModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'مشاوره', url: '/students/consult'},
            ]}/>
            {
                !formCompleted ?
                    <ParentsConsultProfileFormComponent
                        onDone={fetchData}
                    /> :
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>درخواست های مشاوره</b>
                                <button onClick={() => setRequestModal(true)}>
                                    <ThinAddIcon/>
                                    <span>درخواست جدید</span>
                                </button>
                            </div>
                            {
                                requests.length < 1 ?
                                    <div className="staff--not-found">
                                        <em style={{backgroundImage: 'url(/svg/ticket.svg)'}}/>
                                        <b>درخواستی یافت نشد</b>
                                        <p>شما تاکنون درخواست مشاوره ای صادر نکرده‌اید.</p>
                                    </div> : requests.map((t, i) =>
                                        <Link to={`/students/consult/requests/view/${t.id}`}
                                              key={"J39fFk3s9Dks22l3" + i}
                                              className={'ticket-item' + (t.isAnswered ? ' ticket-item-closed' : '')}>
                                            <div>
                                                <i>{t.isAnswered ? <ThinChatUnreadIcon/> : <ThinChatIcon/>}</i>
                                                <div>
                                                    <b className={"max-lines-1"}>{t.description}</b>
                                                    <span>تاریخ {StringDigitsConvertToPersian(GregorianToPersian(t.createdAt).replaceAll('-', '/'))} - {t.isAnswered ? 'بسته شده' : 'در انتظار پاسخ'}</span>
                                                </div>
                                            </div>
                                            <ThinArrowLeft/>
                                        </Link>
                                    )
                            }
                        </div>
                    </div>
            }
            <ParentsConsultAddRequestModal
                active={requestModal}
                closeHandler={()=>setRequestModal(false)}
            />
        </>
    );
};